var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { setIsWriterDeviationFeatured, saveWriterDeviation, saveWriterDeviationSuccess, saveWriterDeviationFailure, saveWriterDeviationFailureDismiss, resetWriterPopup, publishWriterDeviation, setIsRedirecting, } from './actions';
var defaultState = {
    isSubmitting: false,
    isRedirecting: false,
    deviationId: null,
    error: null,
    isFeatured: false,
};
var actionHandlers = (_a = {},
    _a[setIsWriterDeviationFeatured.toString()] = function (state, action) { return (__assign(__assign({}, state), { isFeatured: action.payload.isFeatured })); },
    _a[saveWriterDeviation.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: true, error: null })); },
    _a[publishWriterDeviation.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: true, error: null })); },
    _a[saveWriterDeviationSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: false, deviationId: action.payload.deviationId, error: null })); },
    _a[saveWriterDeviationFailure.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: false, error: action.payload.error })); },
    _a[saveWriterDeviationFailureDismiss.toString()] = function (state, action) { return (__assign(__assign({}, state), { error: null })); },
    _a[setIsRedirecting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isRedirecting: action.payload.isRedirecting })); },
    _a[resetWriterPopup.toString()] = function () { return defaultState; },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        if (state === void 0) { state = defaultState; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map